import { NavigateBackLink } from '@exam-management/components';
import { useParams } from '@exam-management/router';
import { PageHeader } from '@shared/components';

import { useQConfigGeneratorDetails } from '../../providers';

export default function QConfigGeneratorDetailsHeader() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfig-generators/:qConfigGeneratorId');
  const { qconfigGenerator } = useQConfigGeneratorDetails();

  return (
    <PageHeader
      title={qconfigGenerator.name}
      linkAdornment={
        <NavigateBackLink
          to='/exam-courses/:courseId/qconfig-generators'
          params={{ courseId }}
          label='Back'
        />
      }
    />
  );
}
